
import { Vue, Prop, Component } from "vue-property-decorator";
@Component({
  components: {
    ConnectWithSocialNetwork: () =>
      import("@/components/onboarding/ConnectWithSocialNetwork.vue"),
  },
})
export default class OnboardingComponent extends Vue {
  @Prop(Boolean) showOnboarding!: boolean;
  windowWidth: number = 0;

  created() {
    window.addEventListener("resize", (this as any).$root.handleResize);
    (this as any).$root.handleResize();
  }

  destroyed() {
    window.removeEventListener("resize", (this as any).$root.handleResize);
  }
}
